package dev.lingvo.shared.screenshots.doc

import dev.lingvo.shared.DeviceClass
import dev.lingvo.shared.PixelSize
import dev.lingvo.shared.ScreenshotSpecs
import dev.lingvo.shared.ShotPurpose
import dev.lingvo.shared.StorePlatform

/** Binds design boards to store canvases, keeping more permissive raw capture sizes out of exports. */
object StoreDeviceClassRule : DeviceClassRule {
    override fun canonicalId(platform: StorePlatform, raw: String): String? =
        DeviceClass.fromId(raw)?.takeIf { it.platform == platform }?.id

    override fun allows(canonicalId: String, width: Int, height: Int): Boolean =
        DeviceClass.fromId(canonicalId)?.let { device ->
            ScreenshotSpecs.accepts(ScreenshotSpecs.rule(device, ShotPurpose.STORE), PixelSize(width, height))
        } ?: false

    override fun maxSlots(canonicalId: String): Int =
        ScreenshotSpecs.of(requireNotNull(DeviceClass.fromId(canonicalId)) { "Unknown device class" }).maxPerLocale
}
